// Login screen — username/password, login + register. Built once; vsj
// updates only touch the error label (never clobber the inputs).

import { el } from '../kit';
import { sendEvent } from '../net';
import * as vsj from '../vsj';

export function loginScreen(): { root: HTMLElement; onVsj(changed: Set<string>): void } {
  const user = el('input', { class: 'k-input', placeholder: 'Username', autocomplete: 'username' });
  const pass = el('input', {
    class: 'k-input', placeholder: 'Password', type: 'password', autocomplete: 'current-password',
  });
  const error = el('div', { class: 'error-line', style: 'text-align:center' });

  const send = (eventId: string) =>
    sendEvent(eventId, { username: user.value.trim(), password: pass.value });
  pass.addEventListener('keydown', (e) => e.key === 'Enter' && send('login'));
  user.addEventListener('keydown', (e) => e.key === 'Enter' && pass.focus());

  const root = el(
    'div',
    { class: 'center-screen' },
    el(
      'div',
      { class: 'k-panel auth-card' },
      el('div', { class: 'auth-title', text: 'Stoneheim' }),
      user,
      pass,
      el(
        'div',
        { style: 'display:flex;gap:6px;justify-content:center' },
        el('button', { class: 'k-btn', text: 'Log in', onclick: () => send('login') }),
        el('button', { class: 'k-btn', text: 'Register', onclick: () => send('register') }),
      ),
      error,
    ),
  );

  const refresh = () => {
    error.textContent = String(vsj.at('login.error') ?? '');
  };
  refresh();
  setTimeout(() => user.focus(), 0);
  return {
    root,
    onVsj(changed) {
      if (changed.has('login') || changed.has('*')) refresh();
    },
  };
}
